import React from "react";

const CloseIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7472 10.5349C11.9081 10.6958 11.9986 10.9141 11.9986 11.1417C11.9986 11.3694 11.9081 11.5877 11.7472 11.7486C11.5862 11.9096 11.3679 12 11.1403 12C10.9126 12 10.6943 11.9096 10.5333 11.7486L6 7.21413L1.46523 11.7472C1.30427 11.9081 1.08595 11.9986 0.858315 11.9986C0.630676 11.9986 0.41236 11.9081 0.251395 11.7472C0.0904295 11.5862 3.39209e-09 11.3679 0 11.1403C-3.39209e-09 10.9127 0.0904295 10.6944 0.251395 10.5334L4.78616 6.00036L0.252823 1.46586C0.0918573 1.30491 0.00142808 1.0866 0.00142808 0.858978C0.00142808 0.631352 0.0918573 0.413049 0.252823 0.252094C0.413788 0.0911379 0.632104 0.000713864 0.859743 0.000713861C1.08738 0.000713859 1.3057 0.0911379 1.46666 0.252094L6 4.78659L10.5348 0.251379C10.6957 0.0904238 10.914 -3.79225e-09 11.1417 0C11.3693 3.79225e-09 11.5876 0.0904238 11.7486 0.251379C11.9096 0.412335 12 0.630638 12 0.858263C12 1.08589 11.9096 1.30419 11.7486 1.46515L7.21384 6.00036L11.7472 10.5349Z"
        fill="#4A4A4A"
      />
    </svg>
  );
};

export default CloseIcon;
